import { useState, useEffect } from "react";

export const useResponsiveFlex = () => {
  const calculateFlex = () => {
    const width = window.innerWidth;

    return {
      name:
        width <= 768
          ? "10.2"
          : width >= 1600
          ? "11"
          : width >= 1500
          ? "10.7"
          : width < 1100
          ? "10.5"
          : "10.8",
      theme:
        width <= 768
          ? "5.2"
          : width >= 1500
          ? "5.8"
          : width < 1100
          ? "5.5"
          : "5.9",
      point: width <= 768 ? "3.5" : "4",
      action:
        width <= 768 ? "4" : width >= 1500 ? "3.1" : width < 1100 ? "4" : "3.5",
      dragAndDropTheme:
        width <= 768
          ? "12.5"
          : width >= 1600
          ? "12.8"
          : width >= 1500
          ? "12.5"
          : width < 1100
          ? "12.3"
          : "12.8",
      dragAndDropAction:
        width <= 768
          ? "3.4"
          : width >= 1500
          ? "2.5"
          : width < 1100
          ? "3.5"
          : "2.9",
      questionsAction:
        width <= 768
          ? "4.6"
          : width >= 1600
          ? "3"
          : width >= 1500
          ? "3.5"
          : width < 1100
          ? "4.5"
          : "3.9",
      level: "3.1",
      updated: "5",
      blank: "1.4",
      questionsName: width >= 1600 ? "21" : width >= 1500 ? "20.8" : "21",
    };
  };

  const [flexValues, setFlexValues] = useState(calculateFlex());

  useEffect(() => {
    const handleResize = () => setFlexValues(calculateFlex());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return flexValues;
};
